import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'
import {FaLinkedinIn} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Travis Stephenson</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Expeirience</a></li>
        <li><a href="#services">Tools</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/travis.stephenson.9887"><FaFacebookF/></a>
        <a href="https://www.instagram.com/t_moneyswagg/"><FiInstagram/></a>
        <a href="https://twitter.com/TraviLeeHans"><IoLogoTwitter/></a>
        <a href="https://www.linkedin.com/in/trastephenson/"><FaLinkedinIn/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Travis Stephenson All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
